// File: /src/components/Administration/Planner/plannerAdminService.js
import axios from "../../../config/axiosInstance";

// Fetch all planner events for admin
export const fetchPlannerEventsAdmin = async (params = {}) => {
    const response = await axios.get("/planner/admin", { params });
    return response.data;
};

// Fetch one planner event by id
export const fetchPlannerEventByIdAdmin = async (id) => {
    const response = await axios.get(`/planner/admin/${id}`);
    return response.data;
};

// Create planner event
export const createPlannerEventAdmin = async (payload) => {
    const response = await axios.post("/planner/admin", payload);
    return response.data;
};

// Update planner event
export const updatePlannerEventAdmin = async (id, payload) => {
    const response = await axios.put(`/planner/admin/${id}`, payload);
    return response.data;
};

// Soft delete planner event
export const deletePlannerEventAdmin = async (id) => {
    const response = await axios.delete(`/planner/admin/${id}`);
    return response.data;
};

// Fetch available devices for a date range
export const fetchAvailablePlannerDevicesAdmin = async ({ startDate, endDate, type }) => {
    console.log('🔥 fetchAvailablePlannerDevicesAdmin CALLED', { startDate, endDate, type });

    const params = { startDate, endDate };
    if (type) {
        params.idiom = type;
    }

    console.log('📡 Request params:', params);

    const response = await axios.get("/planner/admin/available-devices/list", { params });

    console.log('✅ Response devices:', response.data);

    return response.data;
};

// Fetch all clients
export const fetchClientsAdmin = async () => {
    const response = await axios.get("/clients");
    return response.data;
};

// Fetch all events for admin
export const fetchEventsAdmin = async () => {
    const response = await axios.get("/events/admin");
    return response.data;
};